module.exports = __webpack_public_path__ + "img/blue_097.65a10c4b.png";